module.exports = __webpack_public_path__ + "static/media/alert.4f6abd89.svg";